import React from 'react'
import arrow from '../images/Vector (12) (1).png';

const JoinNowArrow = () => {
  return (
    <div className='JoinNowArrow'>
        <img src={arrow} alt="arrow" className='arrow-image'/>
    </div>
  )
}

export default JoinNowArrow;